import { Component, ElementRef, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AssessmentmanagerService } from 'src/app/services/assessments/assessmentmanager.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { NotificationService } from 'src/app/services/interceptor/notification';
import { ToastrService } from 'ngx-toastr';
import { DateFormatter } from 'src/app/models/datepickerformatterutil';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
declare var toastr: any;
declare var $: any;

@Component({
  selector: 'app-newassessment',
  templateUrl: './newassessment.component.html',
  styleUrls: ['./newassessment.component.css'],
})
export class NewassessmentComponent implements OnInit {
  headertext: string;
  activity: number;
  isEdit = false;
  classID: number;
  // errormessage:string;
  freezePage_formSubmissionInProgress = false;
  QuestionType_MultipleChoice = 'MultipleChoice';
  QuestionType_LongText = 'LongText';
  QuestionType_FileUpload = 'FileUpload';

  backtoConsoleRouteParams: any;

  headerBreadCrumbs: any;

  assessmentItem = {
    id: 0,
    name: '',
    questionType: '',
    endTime: '',
    startTime: '',
    timedType: '',
    rawEndTime: '',
    rawStartTime: '',
    duration: 0,
    weight: 100,
    batchID: 0,
    optional: false,
    essayTextLimit: 0,
    quizAssessment:false
  };

  AssessmentDeliveryMode_TimedAssessment = 'TimedAssessment';
  AssessmentDeliveryMode_UntimedAssessment = 'UntimedAssessment';
  assessmentID: any;
  elementRef: ElementRef;
  isMultipleBatch = false;
  moduleId: number;

  constructor(
    elementRef: ElementRef,
    private activiatedroute: ActivatedRoute,
    private header: ComponentheaderService,
    private toaster: ToastrService,
    private router: Router,
    public assessmentManager: AssessmentmanagerService,
    private headerComponent: ComponentheaderService,
    private notification: NotificationService,
    public modulemanager: ModulemanagementService
  ) {
    headerComponent.setHeaderDisplay('Assessment Setup', [], []);
    //  this.elementRef= elementRef;
    // $(function () {
    //   debugger;
    //   $('#startt').datetimepicker();
    //   console.log('executed datetimepicker from angular2 app constructor');
    // });
  }

  async ngOnInit() {
    //debugger;
    let a = localStorage.getItem(
      this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache
    );
    // let dp=  $(this.elementRef.nativeElement).find('#datetimepicker1');
    // dp.draggable();
    this.classID = this.activiatedroute.snapshot.queryParams.classid;
    this.activity = this.activiatedroute.snapshot.queryParams.activity;
    this.assessmentID = this.activiatedroute.snapshot.queryParams.aid;
    this.checkLessonQuiz();

    if (this.activity == this.assessmentManager.activityType.Edit) {
      this.headertext =
        'Edit : ' +
        localStorage.getItem(
          this.assessmentManager.LocalStorage_FLAG.AssesmentTitle
        );
      this.isEdit = true;
    } else {
      this.headertext = 'Setup new Assessment';
    }

    if (this.isEdit) {
      await this.assessmentManager
        .getAssessmentBreadCrumb(this.assessmentID)
        .toPromise()
        .then((response: any) => {
          this.header.setHeaderDisplay(
            this.headertext,
            [
              {
                displaytext: 'School',
                route: `/user/schoolhome`,
                params: { schoolID: response.schoolID },
              },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: response.moduleID },
              },
              {
                displaytext: 'Lesson',
                route: `/user/lesson`,
                params: { classid: this.classID },
              },
              {
                displaytext: 'Assessments',
                route: `/user/assessmentconsole`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                },
              },
              {
                displaytext: response.assessmentName,
                route: `/user/assessmentdetails`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                  aid: response.assessmentID,
                },
              },
              {
                displaytext: this.headertext,
                route: `/user/editassessment`,
                params: { classid: this.classID, activity: this.activity },
              },
            ],
            []
          );
          this.moduleId = response.moduleID;
        });
    } else {
      await this.assessmentManager
        .getLessonBreadCrumb(this.classID)
        .toPromise()
        .then((response: any) => {
          this.header.setHeaderDisplay(
            this.headertext,
            [
              {
                displaytext: 'School',
                route: `/user/schoolhome`,
                params: { schoolID: response.schoolID },
              },
              {
                displaytext: 'Course',
                route: `/user/moduledetails`,
                params: { moduleID: response.moduleID },
              },
              {
                displaytext: 'Lesson',
                route: `/user/lesson`,
                params: { classid: this.classID },
              },
              {
                displaytext: 'Assessments',
                route: `/user/assessmentconsole`,
                params: {
                  classid: this.classID,
                  batchid: this.assessmentItem.batchID,
                },
              },
              {
                displaytext: this.headertext,
                route: `/user/newassessment`,
                params: { classid: this.classID, activity: this.activity },
              },
            ],
            []
          );
          this.moduleId = response.moduleID;
        });
    }
    this.isMultipleBatch =
      (
        await this.modulemanager
          .getCurrentModuleBatches(this.classID)
          .toPromise()
      ).length > 1;
    //debugger;
  }


  /** Only these assessments feed the course score, so only they need a Weight. */
  get countsTowardsScore(): boolean {
    return !this.assessmentItem?.quizAssessment && !this.assessmentItem?.optional;
  }

  // What the admin had typed before a toggle cleared it, so switching back restores it.
  private stashedWeight: any = null;
  private stashedOptional: any = null;

  /** Optional = Yes: it does not count, so its weight is 0 (the server enforces the same). */
  onOptionalChange(optional: boolean) {
    if (optional) {
      if (this.assessmentItem.weight) this.stashedWeight = this.assessmentItem.weight;
      this.assessmentItem.weight = 0;
    } else if (!this.assessmentItem.weight && this.stashedWeight != null) {
      this.assessmentItem.weight = this.stashedWeight;
    }
  }

  /** Lesson Quiz = Yes: never counts, so Optional is No and weight is 0 (the server enforces the same). */
  onQuizChange(quiz: boolean) {
    if (quiz) {
      this.stashedOptional = this.assessmentItem.optional;
      if (this.assessmentItem.weight) this.stashedWeight = this.assessmentItem.weight;
      this.assessmentItem.optional = false;
      this.assessmentItem.weight = 0;
    } else {
      if (this.stashedOptional != null) this.assessmentItem.optional = this.stashedOptional;
      if (!this.assessmentItem.optional && !this.assessmentItem.weight && this.stashedWeight != null) {
        this.assessmentItem.weight = this.stashedWeight;
      }
    }
  }

  /** True when another assessment on this lesson is already its quiz (one quiz per lesson). */
  lessonHasQuiz = false;

  async checkLessonQuiz() {
    try {
      const res = await this.assessmentManager.getLessonQuizId(this.classID, this.assessmentID || 0);
      this.lessonHasQuiz = res?.quizId > 0;
    }
    catch (e) {
      // not fatal: the server still refuses a second quiz on save
      console.log(e);
    }
  }

  onSubmit(newA: NgForm) {
    // The start and due times are read from the DOM on purpose. They are sent as the displayed
    // string, which the API parses with DateTimeKind.Unspecified and then converts using the
    // user's stored timezone. Sending the bound Date object instead would serialise to UTC, the
    // API would skip that conversion, and every assessment window would shift.
    let stObj = $('#startt')[0];
    let etObj = $('#endt')[0];

    // This check existed and was commented out, leaving nothing to stop an assessment being saved
    // with a due time before its start time. The API does reject it, but only for a course with
    // one running batch, and its message says "Start time must not be in the past" — which is not
    // what went wrong. Checked here so the teacher gets an accurate message before the round trip.
    if (stObj?.value && etObj?.value) {
      const start = new Date(stObj.value).getTime();
      const end = new Date(etObj.value).getTime();
      if (!Number.isNaN(start) && !Number.isNaN(end)) {
        if (end < start) {
          this.toaster.error('The due time cannot be before the start time', 'Error');
          return;
        }
        if (end === start) {
          this.toaster.error('The due time cannot be the same as the start time', 'Error');
          return;
        }
      }
    }

    //let st =DateFormatter.convertDate(stObj.value);
    //let et= DateFormatter.convertDate(etObj.value);
    //     stObj = new Date(stObj.value);
    //     let startdateobj = {
    //       year: stObj.getFullYear(),
    //       month: stObj.getMonth(),
    //       day: stObj.getDate(),
    //       hour: stObj.getHours(),
    //       minute: stObj.getMinutes(),
    //     };

    //     etObj = new Date(etObj.value);
    //     let duedateobj = {
    //       year: etObj.getFullYear(),
    //       month: etObj.getMonth(),
    //       day: etObj.getDate(),
    //       hour: etObj.getHours(),
    //       minute: etObj.getMinutes(),
    //     };

    //  let   st = new Date(
    //       Date.UTC(
    //         startdateobj.year,
    //         startdateobj.month,
    //         startdateobj.day,
    //         startdateobj.hour,
    //         startdateobj.minute
    //       )
    //     );

    //   let  et = new Date(
    //       Date.UTC(
    //         duedateobj.year,
    //         duedateobj.month,
    //         duedateobj.day,
    //         duedateobj.hour,
    //         duedateobj.minute
    //       )
    //     );

    // if (st.getTime() > et.getTime()) {
    //   this.toaster.error(
    //     'Assessment start time can not be after due time',
    //     'Error'
    //   );
    //   return;
    // }
    // if (st.getTime() === et.getTime()) {
    //   this.toaster.error(
    //     'Assessment due time can not be the same as start time',
    //     'Error'
    //   );
    //   return;
    // }

    let wt = $('#weight')[0];
    let dr = $('#duration')[0];
    let frmData = {
      starttime: stObj.value,
      endtime: etObj.value,
      name: $('#name')[0].value,
      // the Weight box is not rendered for a lesson quiz, so it may be missing here
      weight: wt?.value ? wt.value : 0,
      duration: dr?.value ? dr.value : 0,
      // Read from the model, not the DOM. With [ngValue] the rendered option value is Angular's
      // internal index ("0: true"), so a DOM read here would send that string instead of the
      // boolean. The date fields below are deliberately still read from the DOM — see onSubmit.
      optional: this.assessmentItem.optional,
      quizAssessment: this.assessmentItem.quizAssessment,
    };
    this.freezePage_formSubmissionInProgress = true;
    let formData: any;
    //this.loadingMessage = "Saving new Assessment. Please wait..."
    this.notification.currentNotificationType =
      this.notification.CALL_TYPE.POST_FORM_DATA;
    this.notification.notificationMessageBody = 'Saving Assessment...';
    this.notification.notificationMessageHeader = 'Saving';
    // if (newA.value.duration == "" || newA.value.duration == undefined || !newA.value.duration) {
    //   newA.value.duration = 0;
    // }
    // if (newA.value.weight == "" || newA.value.weight == undefined || !newA.value.weight) {
    //   newA.value.weight = 0;
    // }
    if (
      frmData.duration == '' ||
      frmData.duration == undefined ||
      !frmData.duration
    ) {
      frmData.duration = 0;
    }
    if (
      frmData.weight == '' ||
      frmData.weight == undefined ||
      !frmData.weight
    ) {
      frmData.weight = 0;
    }

    formData = {
      id: this.assessmentItem.id,
      classID: this.classID,
      timeZoneStartTime: frmData.starttime,
      timeZoneStopTime: frmData.endtime,
      name: frmData.name,
      weight: Number.parseFloat(frmData.weight),
      deliveryMode: newA.value.deliveryMode,
      assessmentType: newA.value.assessmentType,
      duration: Number.parseFloat(frmData.duration),
      optional: frmData.optional,
      essayTextLimit: newA.value.essayTextLimit,
      quizAssessment: newA.value.quizAssessment
    };
    if (!formData.timeZoneStartTime) {
      formData.timeZoneStartTime = '0001-01-01T00:00:00';
    }
    if (!formData.timeZoneStopTime) {
      formData.timeZoneStopTime = '0001-01-01T00:00:00';
    }
    
    if (this.isEdit == false) {
      this.assessmentManager
        .createAssessment(formData)
        .subscribe((data: any) => {
          this.toaster.success('Assessment Saved', 'Success');
          //navigate to details using the returned id
          this.router.navigate(['/user/assessmentdetails'], {
            queryParams: {
              aid: data,
              classid: this.classID,
              batchid: this.assessmentItem.batchID,
              target: this.assessmentManager.bufferRoute.Details,
            },
          });
        })
        .add(() => {
          this.freezePage_formSubmissionInProgress = false;
        });
    } else {
      this.assessmentManager
        .updateAssessment(formData)
        .subscribe((data: any) => {
          //navigate to details using the returned id
          this.toaster.success('Assessment Updated', 'Success');
          this.router.navigate(['/buffer'], {
            queryParams: {
              classid: this.classID,
              aid: data,
              batchid: this.assessmentItem.batchID,
              target: this.assessmentManager.bufferRoute.Details,
            },
          });
          //  this.router.navigate(['/buffer'], {queryParams:{id:data,classid:this.classID}});
        })
        .add(() => {
          this.freezePage_formSubmissionInProgress = false;
        });
    }
  }

  ngAfterViewInit() {
    if (this.isEdit) {
      this.assessmentItem = JSON.parse(
        localStorage.getItem(
          this.assessmentManager.LocalStorage_FLAG.currentAssessmentCache
        )
      );
      this.assessmentItem.batchID=0;
      if (this.assessmentItem.rawStartTime == '0001-01-01T00:00:00') {
        this.assessmentItem.rawStartTime = null;
      }
      if (this.assessmentItem.rawEndTime == '0001-01-01T00:00:00') {
        this.assessmentItem.rawEndTime = null;
      }
    }
    //JQUERY - CODE FOR MANAGING ASSESSMENT CREATION - NOT REQUIRED FOR EDITING
    $('#adm').on('change', function (event) {
      if ('UntimedAssessment' == $(this).val()) {
        $('#durationHolder').hide();
        $('#duration').val('0');
      } else {
        $('#durationHolder').show();
      }
    });

    const assessmentTimedType = this.assessmentItem.timedType;
    $('#crt-new-asmt').on('click', function (e) {
      if (
        ($('#adm').val() === 'TimedAssessment' ||
          assessmentTimedType === 'TimedAssessment') &&
        $('#duration').val() == 0
      ) {
        e.preventDefault();
        toastr.error('Please provide a duration for the TIMED Assessment');
      }
    });

    // debugger;
    // $(function () {
    //  // debugger;
    //   // $('#datetimepicker1').datepicker();
    //   // $(this.elementRef.nativeElement).find;
    //   //  $('#startt').datepicker();
    // });

    // debugger;
    //    $(document).ready(function () {
    //      debugger;
    //      $('#datetimepicker1').draggable();
    //     // $('#datetimepicker1').datetimepicker.setLocale('en');

    //    });
  }
}
